import { call, put, takeEvery } from 'redux-saga/effects';
import { getCapVariants } from '../../../requests/cap_requests/get_cap_variants_request';
import { getLeadsCapVersionsRequestSuccess, getLeadsCapVersionsRequestFailure } from '../../actions/cap_actions/get_cap_versions.actions';
import { GET_LEADS_CAP_VERSIONS_REQUEST } from '../../constants/cap.constants';
import { message_error } from '../../../../../../components/Message';

function* getCapVersionsRequest({ model_id }) {
    const { result, options, error } = yield call(getCapVariants, model_id);
    if (result) {
        yield put(getLeadsCapVersionsRequestSuccess(options));
    } else {
        yield put(getLeadsCapVersionsRequestFailure(error));
        message_error(error);
    }
}

export default function* getCapVersionsSaga() {
    yield takeEvery(GET_LEADS_CAP_VERSIONS_REQUEST, getCapVersionsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/cap.sagas/get_cap_versions.saga.js